export default "__VITE_ASSET__CgYxaora__"